var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m384 240 40-40h24l-16 80-22.036 3.273z",
    fill: "#e0edff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m409.964 283.273-185.118 27.5v-70.773h159.154z",
    fill: "#ffbfa1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m272 287.1499a47.07351 47.07351 0 0 1 -3.21 17.0901l-52.79 135.76-56 24 40-152h-68a60.01018 60.01018 0 0 1 -58.79-72h151.6401a47.15007 47.15007 0 0 1 47.1499 47.1499z",
    fill: "#ffceb6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m160 240 16-48a53.66555 53.66555 0 0 0 24-24v-24h-88l-35.38462 84.92309a59.99877 59.99877 0 0 0 -3.40312 11.07691z",
    fill: "#ef5e3b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m136 44-19.90027-9.95014a19.41644 19.41644 0 0 0 -8.68327-2.04986 19.41638 19.41638 0 0 0 -19.41641 19.41639v18.64252a81.94105 81.94105 0 0 1 -24 57.94107h24a40 40 0 0 0 40-40v-15.99998z",
    fill: "#b1712c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m144 72 16-16h32v32a32 32 0 0 1 -32 32 32 32 0 0 1 -32-32v-16z",
    fill: "#ffceb6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m128 72v-16a32 32 0 0 1 32-32 32 32 0 0 1 32 32h-32l-16 16z",
    fill: "#c78640"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m136 120h128l24-24h8v24h40v16l-24 8v8a16 16 0 0 1 -16 16h-160a24 24 0 0 1 -24-24 24 24 0 0 1 24-24z",
    fill: "#ffceb6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m176 240v72h-44a60.01018 60.01018 0 0 1 -58.79-72z",
    fill: "#ffa100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m160 464 56-24 40 24v24h-96z",
    fill: "#e0edff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkout);
export default __webpack_public_path__ + "static/media/workout.8c72d3d5ea854118b4bcad4c9dde15c2.svg";
export { ForwardRef as ReactComponent };